/**
 * Intitulé public unique de l'équipe Carte grise Skipcar.
 *
 * Côté agence, tous les comptes Skipcar (god, arbitrator, head) s'affichent
 * sous ce seul nom : demande François du 01/12/2025, « l'intitulé doit être
 * systématiquement Service Carte grise Skipcar ». Le backend applique le même
 * masquage sur les réponses API servies aux agences (cf.
 * `maskSkipcarCommentAuthors`) : cette constante n'est que la défense d'affichage.
 *
 * En vue interne, on affiche au contraire le nom réel de l'auteur.
 */
export const SKIPCAR_CG_PUBLIC_AUTHOR = 'Service Carte grise Skipcar';
